function Title() {
  return (
    <div className="title">
      <h1>FotoBucket</h1>
      <h2>Share Your Pictures.</h2>
    </div>
  );
}
export default Title;
